import api from './api';

/**
 * @typedef {
    | 'draft'
    | 'queued_for_pregrading'
    | 'pregrading'
    | 'pretesting'
    | 'queued_for_live'
    | 'live'
    | 'withdrawn'
    | 'archived'
 * } TestStatus
 */

/**
 * @returns {Promise<{
 *  test_group_id: string
 *  name: string
 *  status: TestStatus
 * }[]>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-TestGroups-getAllTestGroups
 */
export default async function getTests(level_id) {
    const { data } = await api.get(`levels/${level_id}/test_groups`);

    return data;
}